import { pagePathUtils } from "~/utils";

export type MenuType =
  | "Home"
  | "Notifications"
  | "Heart"
  | "ChatbubbleEllipses"
  | "Mail"
  | "Bookmark";

type MenusPropsType = {
  type: MenuType;
  href?: string;
  label: string;
};

type ReturnType = {
  menus: MenusPropsType[];
};

export const useMenus = (): ReturnType => {
  const isManagers = pagePathUtils.isManagerPage();
  const isAnalyticsPlans = pagePathUtils.isAnalyticsPlansPage();
  const menus: MenusPropsType[] = [
    {
      type: "Home",
      href: isManagers
        ? "/managers"
        : isAnalyticsPlans
          ? "/analytics_plans"
          : "/",
      label: "ホーム",
    },
    { type: "ChatbubbleEllipses", label: "リプライ" },
    { type: "Mail", label: "メッセージ" },
    { type: "Notifications", label: "メンション" },
    { type: "Heart", label: "いいね" },
    { type: "Bookmark", label: "ブクマ" },
  ];
  return { menus };
};
